module.exports = __webpack_public_path__ + "img/img_5.9d7e439d.jpeg";